/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export enum VarType {
  SCADA = "SCADA",
  TASK = "TASK",
  INPUT = "INPUT",
  DEVICE = "DEVICE",
}

export enum TicketStatus {
  Open = "Open",
  InProgress = "InProgress",
  Resolved = "Resolved",
  Closed = "Closed",
  Cancelled = "Cancelled",
}

export enum TicketPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Critical = "Critical",
}

export enum TicketCategory {
  Bug = "Bug",
  Feature = "Feature",
  Support = "Support",
  Contact = "Contact",
  General = "General",
}

export enum TableType {
  DEFAULT = "DEFAULT",
  ADVANCE = "ADVANCE",
}

export enum ResponseCodes {
  Ok = "Ok",
  ErrorToken = "ErrorToken",
  OriginAccess = "OriginAccess",
  InvalidUserName = "InvalidUserName",
  InvalidPassword = "InvalidPassword",
  BdConectionFailed = "BdConectionFailed",
  NoDataFound = "NoDataFound",
  SaveDataFailed = "SaveDataFailed",
  SinEmpresa = "SinEmpresa",
  AccesoNoAutorizado = "AccesoNoAutorizado",
  DataError = "DataError",
  OtherError = "OtherError",
  InvalidModel = "InvalidModel",
  InvalidAccessType = "InvalidAccessType",
  InvalidToken = "InvalidToken",
}

export enum PermissionLevel {
  READ = "READ",
  WRITE = "WRITE",
  ADMIN = "ADMIN",
}

export enum OrderType {
  Up = "up",
  Down = "down",
}

export enum NotificationType {
  Info = "Info",
  Warning = "Warning",
  Alert = "Alert",
  Success = "Success",
}

export enum NotificationPriority {
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Critical = "Critical",
}

export enum NodeType {
  BASE = "BASE",
  INFORMATIVE = "INFORMATIVE",
  VALUE = "VALUE",
}

export enum Limit {
  VERY_HIGH = "VERY_HIGH",
  HIGH = "HIGH",
  LOW = "LOW",
  VERY_LOW = "VERY_LOW",
}

export enum ExportFileType {
  CSV = "CSV",
  XLSX = "XLSX",
  JSON = "JSON",
}

export enum EntityType {
  CLIENT = "CLIENT",
  PLANT = "PLANT",
  DASHBOARDGROUP = "DASHBOARDGROUP",
  DASHBOARD = "DASHBOARD",
  ALERT = "ALERT",
  DIAGRAM = "DIAGRAM",
}

export enum DiagramNavigationType {
  NONE = "NONE",
  DASHBOARD = "DASHBOARD",
  DIAGRAM = "DIAGRAM",
}

export enum DiagramEdgeType {
  DEFAULT = "DEFAULT",
  STRAIGHT = "STRAIGHT",
  STEP = "STEP",
  SMOOTHSTEP = "SMOOTHSTEP",
  SIMPLEBEZIER = "SIMPLEBEZIER",
}

export enum DeviceType {
  UNKNOWN = "UNKNOWN",
  API = "API",
  DEVICE = "DEVICE",
  PLC = "PLC",
}

export enum CsvFilterOperator {
  Equal = "Equal",
  NotEqual = "NotEqual",
  GreaterThan = "GreaterThan",
  GreaterThanOrEqual = "GreaterThanOrEqual",
  LessThan = "LessThan",
  LessThanOrEqual = "LessThanOrEqual",
  Contains = "Contains",
  StartsWith = "StartsWith",
  EndsWith = "EndsWith",
}

export enum CsvFilterLogicOperator {
  And = "And",
  Or = "Or",
}

export enum CsvDataType {
  String = "String",
  Int = "Int",
  Double = "Double",
  Bool = "Bool",
  DateTime = "DateTime",
}

export enum ChartType {
  LINE = "LINE",
  BAR = "BAR",
  PIE = "PIE",
  GRID = "GRID",
  GAUGE = "GAUGE",
  VALUE = "VALUE",
  PROGRESS = "PROGRESS",
  INPUT = "INPUT",
  DEVICESTATE = "DEVICESTATE",
}

export enum ChartQueryType {
  DASHBOARD = "DASHBOARD",
  DIAGRAM = "DIAGRAM",
  BASE = "BASE",
  INPUT = "INPUT",
}

export enum CalculationType {
  AVERAGE = "AVERAGE",
  SUM = "SUM",
  MAX = "MAX",
  MIN = "MIN",
  TOTALIZED = "TOTALIZED",
  ADVANCED_CALCULATION = "ADVANCED_CALCULATION",
}

export enum AlertStatus {
  STANDBY = "STANDBY",
  ACKNOWLEDGED = "ACKNOWLEDGED",
  INACTIVE = "INACTIVE",
  ACTIVE = "ACTIVE",
}

export interface AddColumnsToSchemaRequest {
  /** @format int32 */
  csvSchemaId: number;
  /** @minItems 1 */
  columns: CsvColumnDefinition[];
}

export interface AlertDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  category?: string | null;
  text?: string | null;
  /** @format double */
  veryHighLimit?: number | null;
  /** @format double */
  highLimit?: number | null;
  /** @format double */
  lowLimit?: number | null;
  /** @format double */
  veryLowLimit?: number | null;
  /** @format date-time */
  lastUpdate?: string | null;
  /** @format date-time */
  created?: string | null;
  status?: AlertStatus;
  isActive?: boolean;
  /** @format int32 */
  variableId?: number | null;
  /** @format int32 */
  zoneId?: number | null;
  variable?: Variable;
  zone?: Zone;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
}

export interface AlertExecutionDto {
  /** @format int32 */
  id?: number;
  limitSurpassed?: Limit;
  triggeredStatus?: AlertStatus;
  /** @format date-time */
  started?: string | null;
  /** @format int32 */
  alertId?: number;
}

export interface Annotation {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  zoneId?: number | null;
  chartAnnotations?: ChartAnnotations[] | null;
  zone?: Zone;
  annotationsData?: AnnotationsData[] | null;
}

export interface AnnotationDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  zoneId?: number | null;
}

export interface AnnotationsData {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  timestamp?: string | null;
  text?: string | null;
  /** @format int32 */
  annotationId?: number | null;
  annotation?: Annotation;
}

export interface AnnotationsDataDto {
  /** @format int32 */
  id?: number;
  /** @format date-time */
  timestamp?: string | null;
  text?: string | null;
  /** @format int32 */
  annotationId?: number | null;
}

export interface AssignTicketRequestDto {
  /** @minLength 1 */
  assignedToUserId: string;
}

export interface BulkVariableScadaDto {
  variableName?: string | null;
  scadaReferenceName?: string | null;
  zoneName?: string | null;
  tableName?: string | null;
}

export interface ChartAnnotations {
  /** @format int32 */
  id?: number;
  color?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  chartQueryId?: number;
  chartQuery?: ChartQuery;
  /** @format int32 */
  annotationId?: number | null;
  annotation?: Annotation;
}

export interface ChartAnnotationsDto {
  /** @format int32 */
  id?: number;
  color?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  chartQueryId?: number;
  /** @format int32 */
  annotationId?: number | null;
  annotation?: AnnotationDto;
}

export interface ChartQuery {
  /** @format int32 */
  id?: number;
  chartType?: ChartType;
  chartQueryType?: ChartQueryType;
  title?: string | null;
  /** @format int32 */
  numeroDecimales?: number | null;
  filterStartDate?: string | null;
  filterEndDate?: string | null;
  streaming?: boolean | null;
  lastHours?: boolean | null;
  lock?: boolean;
  singleValueStyle?: SingleValueChartStyle;
  /** @format int32 */
  yAxisMax?: number | null;
  /** @format int32 */
  yAxisMin?: number | null;
  /** @format int32 */
  y1AxisMax?: number | null;
  /** @format int32 */
  y1AxisMin?: number | null;
  yAxisLabel?: string | null;
  y1AxisLabel?: string | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  max1?: number | null;
  /** @format int32 */
  max2?: number | null;
  instantaneoActivado?: boolean;
  instantExpression?: string | null;
  instantFormula?: string | null;
  instantaneoTipoCalculo?: CalculationType;
  unit?: string | null;
  unitConversion?: string | null;
  variables?: ChartVariable[] | null;
  annotations?: ChartAnnotations[] | null;
}

export interface ChartQueryDto {
  /** @format int32 */
  id?: number;
  chartType?: ChartType;
  chartQueryType?: ChartQueryType;
  title?: string | null;
  /** @format int32 */
  numeroDecimales?: number | null;
  filterStartDate?: string | null;
  filterEndDate?: string | null;
  streaming?: boolean | null;
  lastHours?: boolean | null;
  lock?: boolean;
  singleValueStyle?: SingleValueChartStyleDto;
  /** @format int32 */
  yAxisMax?: number | null;
  /** @format int32 */
  yAxisMin?: number | null;
  /** @format int32 */
  y1AxisMax?: number | null;
  /** @format int32 */
  y1AxisMin?: number | null;
  yAxisLabel?: string | null;
  y1AxisLabel?: string | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  max1?: number | null;
  /** @format int32 */
  max2?: number | null;
  instantFormula?: string | null;
  instantaneoActivado?: boolean;
  instantExpression?: string | null;
  instantaneoTipoCalculo?: CalculationType;
  unit?: string | null;
  unitConversion?: string | null;
  /** @format int32 */
  layoutId?: number | null;
  /** @format int32 */
  valueNodeId?: number | null;
  variables?: ChartVariableDto[] | null;
  chartAnnotations?: ChartAnnotationsDto[] | null;
}

export interface ChartQueryFilterRequestDto {
  /** @format int32 */
  dashboardId?: number;
  /** @format date-time */
  startTime?: string | null;
  /** @format date-time */
  endTime?: string | null;
  /** @format int32 */
  minutes?: number | null;
}

export interface ChartVariable {
  /** @format int32 */
  id?: number;
  color?: string | null;
  axis?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  chartQueryId?: number;
  chartQuery?: ChartQuery;
  /** @format int32 */
  variableId?: number;
  variable?: Variable;
}

export interface ChartVariableDto {
  /** @format int32 */
  id?: number;
  color?: string | null;
  axis?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  chartQueryId?: number;
  /** @format int32 */
  variableId?: number;
  variable?: VariableDto;
}

export interface CheckVariableTaskRequestDto {
  taskData?: CreateVariableTaskDto;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
}

export interface Client {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  clientName: string;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  plants?: Plant[] | null;
  roles?: RolePermission[] | null;
}

export interface ClientDto {
  /** @format int32 */
  id?: number;
  clientName?: string | null;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
}

export interface ClientStatisticsResponseDto {
  /** @format int32 */
  clientId?: number;
  clientName?: string | null;
  /** @format int32 */
  scadaVariables?: number;
  /** @format int32 */
  dashboards?: number;
  /** @format int32 */
  tasks?: number;
  /** @format int32 */
  users?: number;
}

export interface CreateAlertDto {
  name?: string | null;
  description?: string | null;
  category?: string | null;
  text?: string | null;
  /** @format double */
  veryHighLimit?: number | null;
  /** @format double */
  highLimit?: number | null;
  /** @format double */
  lowLimit?: number | null;
  /** @format double */
  veryLowLimit?: number | null;
  /** @format int32 */
  variableId?: number | null;
  /** @format int32 */
  zoneId?: number | null;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateAlertExecutionDto {
  limitSurpassed?: Limit;
  triggeredStatus?: AlertStatus;
  /** @format int32 */
  alertId?: number;
}

export interface CreateAnnotationDto {
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  zoneId?: number | null;
}

export interface CreateAnnotationsDataDto {
  /** @format date-time */
  timestamp?: string | null;
  text?: string | null;
  /** @format int32 */
  annotationId?: number | null;
}

export interface CreateChartAnnotationsDto {
  color?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  chartQueryId?: number;
  /** @format int32 */
  annotationId?: number | null;
}

export interface CreateChartQueryDto {
  chartType?: ChartType;
  chartQueryType?: ChartQueryType;
  title?: string | null;
  /** @format int32 */
  numeroDecimales?: number | null;
  filterStartDate?: string | null;
  filterEndDate?: string | null;
  streaming?: boolean | null;
  lastHours?: boolean | null;
  lock?: boolean;
  /** @format int32 */
  yAxisMax?: number | null;
  /** @format int32 */
  yAxisMin?: number | null;
  /** @format int32 */
  y1AxisMax?: number | null;
  /** @format int32 */
  y1AxisMin?: number | null;
  yAxisLabel?: string | null;
  y1AxisLabel?: string | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  max1?: number | null;
  /** @format int32 */
  max2?: number | null;
  instantaneoActivado?: boolean;
  instantFormula?: string | null;
  instantExpression?: string | null;
  instantaneoTipoCalculo?: CalculationType;
  unit?: string | null;
  unitConversion?: string | null;
  singleValueStyle?: SingleValueChartStyleDto;
  /** @format int32 */
  layoutId?: number | null;
  /** @format int32 */
  valueNodeId?: number | null;
}

export interface CreateClientDto {
  clientName?: string | null;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateCsvRecordBatchItemRequest {
  /** @format date-time */
  recordTimestampUtc?: string | null;
  /** @minLength 1 */
  values: Record<string, any>;
}

export interface CreateCsvRecordRequest {
  /** @format int32 */
  csvSchemaId: number;
  /** @format date-time */
  recordTimestampUtc?: string | null;
  /** @minLength 1 */
  values: Record<string, any>;
}

export interface CreateCsvSchemaRequest {
  /** @format int32 */
  plantId: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
  /** @minItems 1 */
  columns: CsvColumnDefinition[];
}

export interface CreateDashboardDto {
  dashboardName?: string | null;
  /** @format int32 */
  dashboardGroupId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateDashboardGroupDto {
  groupName?: string | null;
  /** @format int32 */
  plantId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateDataExportDto {
  name?: string | null;
  description?: string | null;
  variableIds?: number[] | null;
  /** @format int32 */
  limit?: number;
  fromExpression?: string | null;
  toExpression?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  fileType?: ExportFileType;
  cronExpression?: string | null;
  timeZone?: string | null;
  emails?: string[] | null;
  userId?: string | null;
  /** @format int32 */
  exportTemplateId?: number | null;
}

export interface CreateDeviceDto {
  /** @format int32 */
  id?: number;
  variableName?: string | null;
  deviceType?: DeviceType;
  /** @format int32 */
  deviceId?: number | null;
  ipAddress?: string | null;
  /** @format int32 */
  tableId?: number | null;
  /** @format int32 */
  priority?: number | null;
}

export interface CreateDiagramDto {
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  plantId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateDiagramEdgeDto {
  /** @format int32 */
  diagramId?: number;
  /** @format int32 */
  sourceNodeId?: number;
  /** @format int32 */
  targetNodeId?: number;
  edgeType?: DiagramEdgeType;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  animated?: boolean;
  color?: string | null;
  /** @format double */
  strokeWidth?: number;
  label?: string | null;
}

export interface CreateDiagramNodeDto {
  /** @format int32 */
  diagramId?: number;
  nodeType?: NodeType;
  diagramNavigationType?: DiagramNavigationType;
  /** @format int32 */
  childDiagramId?: number | null;
  /** @format int32 */
  dashboardId?: number | null;
  label?: string | null;
  text?: string | null;
  backgroundColor?: string | null;
  textColor?: string | null;
  /** @format int32 */
  variableId?: number | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  min3?: number | null;
  /** @format int32 */
  min4?: number | null;
  /** @format double */
  positionX?: number;
  /** @format double */
  positionY?: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
  isOn?: boolean | null;
  hasRange?: boolean | null;
  /** @format int32 */
  parentId?: number | null;
}

export interface CreateEditRemoveResponseDto {
  success?: boolean;
  message?: string | null;
  errors?: GenericErrorDto[] | null;
  /** @format int32 */
  id?: number;
}

export interface CreateEntityRolePermissionDto {
  role?: string | null;
  permissionLevel?: PermissionLevel;
}

export interface CreateLayoutDto {
  /** @format int32 */
  x?: number | null;
  /** @format int32 */
  y?: number | null;
  /** @format int32 */
  i?: number | null;
  /** @format int32 */
  w?: number | null;
  /** @format int32 */
  h?: number | null;
  /** @format int32 */
  minW?: number | null;
  /** @format int32 */
  minH?: number | null;
  staticItem?: boolean | null;
  /** @format int32 */
  dashboardId?: number;
}

export interface CreateNotificationDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 2000
   */
  content: string;
  /** @format date-time */
  expiresAt?: string | null;
  priority?: NotificationPriority;
  type?: NotificationType;
}

export interface CreatePlantDto {
  plantName?: string | null;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  /** @format int32 */
  clientId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
}

export interface CreateResponseDto {
  success?: boolean;
  message?: string | null;
  errors?: GenericErrorDto[] | null;
  /** @format int32 */
  id?: number;
  data?: any;
}

export interface CreateRoleDto {
  name?: string | null;
}

export interface CreateRolePermissionDto {
  roleId?: string | null;
  entityType?: EntityType;
  /** @format int32 */
  entityId?: number;
  permissionLevel?: PermissionLevel;
}

export interface CreateTableAdvanceDto {
  tableName?: string | null;
  /** @format int32 */
  zoneId?: number;
  monitorPath?: string | null;
}

export interface CreateTableDto {
  tableName?: string | null;
  /** @format int32 */
  zoneId?: number;
}

export interface CreateTelegramGroupDto {
  name?: string | null;
  roleId?: string | null;
}

export interface CreateTemplateExportScheduleDto {
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  exportTemplateId?: number;
  cronExpression?: string | null;
  timeZone?: string | null;
  fromExpression?: string | null;
  toExpression?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  emails?: string[] | null;
  userId?: string | null;
}

export interface CreateTicketDto {
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * @minLength 1
   * @maxLength 5000
   */
  description: string;
  category: TicketCategory;
  priority?: TicketPriority;
}

export interface CreateUserDto {
  userName?: string | null;
  password?: string | null;
  /** @format email */
  email?: string | null;
  phoneNumber?: string | null;
  fullName?: string | null;
  roles?: string[] | null;
}

export interface CreateVariableDto {
  variableName?: string | null;
  varType?: VarType;
  description?: string | null;
  /** @format int32 */
  tableId?: number | null;
}

export interface CreateVariableScadaDto {
  variableName?: string | null;
  varType?: VarType;
  description?: string | null;
  scadaReferenceName?: string | null;
  /** @format int32 */
  tableId?: number;
}

export interface CreateVariableTaskDto {
  variableName?: string | null;
  description?: string | null;
  calculationType?: CalculationType;
  calculationFormula?: string | null;
  unitChange?: string | null;
  /** @format date-span */
  lookbackPeriod?: string | null;
  cronExpression?: string | null;
  timeZone?: string | null;
  /** @format int32 */
  tableId?: number | null;
  /** @format int32 */
  zoneId?: number | null;
  /** @format int32 */
  variableId?: number | null;
  formulaVariables?: CreateVariableTaskVariableDto[] | null;
}

export interface CreateVariableTaskVariableDto {
  /** @format int32 */
  variableId?: number;
  referencia?: string | null;
}

export interface CreateZoneDto {
  zoneName?: string | null;
  /** @format int32 */
  plantId?: number;
}

export interface CsvColumnDefinition {
  /**
   * @minLength 1
   * @maxLength 128
   */
  header: string;
  dataType: CsvDataType;
  isRequired?: boolean;
  isPrimary?: boolean;
}

export interface CsvColumnFilterDto {
  /** @format int32 */
  columnId: number;
  operator: CsvFilterOperator;
  value?: any;
}

export interface CsvColumnResponse {
  /** @format int32 */
  id?: number;
  header: string | null;
  dataType?: CsvDataType;
  isRequired?: boolean;
  isPrimary?: boolean;
}

export interface CsvRecordFilterRequestDto {
  /** @format int32 */
  csvSchemaId: number;
  filters?: CsvColumnFilterDto[] | null;
  logicOperator?: CsvFilterLogicOperator;
  /** @format date-time */
  fromDate?: string | null;
  /** @format date-time */
  toDate?: string | null;
  /**
   * @format int32
   * @min 1
   * @max 10000
   */
  limit?: number | null;
  /**
   * @format int32
   * @min 0
   * @max 2147483647
   */
  offset?: number;
  orderByDescending?: boolean;
}

export interface CsvRecordResponse {
  /** @format int64 */
  id?: number;
  /** @format int32 */
  csvSchemaId?: number;
  /** @format date-time */
  recordTimestampUtc?: string;
  values: Record<string, any>;
}

export interface CsvSchemaResponse {
  /** @format int32 */
  id?: number;
  name: string | null;
  /** @format date-time */
  createdUtc?: string;
  /** @format int32 */
  plantId?: number;
  columns: CsvColumnResponse[] | null;
}

export interface Dashboard {
  /** @format int32 */
  id?: number;
  dashboardName?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  dashboardGroupId?: number;
  dashboardGroup?: DashboardGroup;
  layouts?: Layout[] | null;
  roles?: RolePermission[] | null;
}

export interface DashboardChartQuery {
  /** @format int32 */
  id?: number;
  chartType?: ChartType;
  chartQueryType?: ChartQueryType;
  title?: string | null;
  /** @format int32 */
  numeroDecimales?: number | null;
  filterStartDate?: string | null;
  filterEndDate?: string | null;
  streaming?: boolean | null;
  lastHours?: boolean | null;
  lock?: boolean;
  singleValueStyle?: SingleValueChartStyle;
  /** @format int32 */
  yAxisMax?: number | null;
  /** @format int32 */
  yAxisMin?: number | null;
  /** @format int32 */
  y1AxisMax?: number | null;
  /** @format int32 */
  y1AxisMin?: number | null;
  yAxisLabel?: string | null;
  y1AxisLabel?: string | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  max1?: number | null;
  /** @format int32 */
  max2?: number | null;
  instantaneoActivado?: boolean;
  instantExpression?: string | null;
  instantFormula?: string | null;
  instantaneoTipoCalculo?: CalculationType;
  unit?: string | null;
  unitConversion?: string | null;
  variables?: ChartVariable[] | null;
  annotations?: ChartAnnotations[] | null;
  /** @format int32 */
  layoutId?: number | null;
  layout?: Layout;
}

export interface DashboardDto {
  /** @format int32 */
  id?: number;
  dashboardName?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  dashboardGroupId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
}

export interface DashboardGroup {
  /** @format int32 */
  id?: number;
  groupName?: string | null;
  /** @format int32 */
  position?: number;
  dashboards?: Dashboard[] | null;
  /** @format int32 */
  plantId?: number;
  plant?: Plant;
  roles?: RolePermission[] | null;
}

export interface DashboardGroupDto {
  /** @format int32 */
  id?: number;
  groupName?: string | null;
  /** @format int32 */
  position?: number;
  /** @format int32 */
  plantId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
}

export interface DataRangeExportDto {
  variableIds?: number[] | null;
  /** @format int32 */
  intervalSeconds?: number;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  fileType?: ExportFileType;
  timeZone?: string | null;
  separatedDateTime?: boolean;
}

export interface Diagram {
  /** @format int32 */
  id?: number;
  /** @maxLength 200 */
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  plantId?: number;
  plant?: Plant;
  nodes?: DiagramNode[] | null;
  edges?: DiagramEdge[] | null;
  rolePermissions?: RolePermission[] | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface DiagramBulkPositionUpdateRequest {
  updateNodes?: UpdateBulkNodePositionRequest[] | null;
}

export interface DiagramDto {
  /** @format int32 */
  id?: number;
  description?: string | null;
  name?: string | null;
  /** @format int32 */
  plantId?: number;
  nodes?: DiagramNodeDto[] | null;
  edges?: DiagramEdgeDto[] | null;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface DiagramEdge {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  diagramId: number;
  diagram?: Diagram;
  /** @format int32 */
  sourceNodeId?: number;
  /** @format int32 */
  targetNodeId?: number;
  edgeType?: DiagramEdgeType;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  /** @format double */
  strokeWidth?: number;
  /** @maxLength 200 */
  label?: string | null;
  animated?: boolean;
  color?: string | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface DiagramEdgeDto {
  /** @format int32 */
  id?: number | null;
  /** @format int32 */
  diagramId?: number | null;
  /** @format int32 */
  sourceNodeId?: number | null;
  /** @format int32 */
  targetNodeId?: number | null;
  sourceHandle?: string | null;
  targetHandle?: string | null;
  edgeType?: DiagramEdgeType;
  animated?: boolean | null;
  color?: string | null;
  /** @format double */
  strokeWidth?: number | null;
  label?: string | null;
  createdAt?: string | null;
  updatedAt?: string | null;
}

export interface DiagramNode {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  diagramId?: number;
  diagram?: Diagram;
  nodeType?: NodeType;
  label?: string | null;
  text?: string | null;
  /** @format double */
  positionX?: number;
  /** @format double */
  positionY?: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
  /** @format int32 */
  parentId?: number | null;
  /** @format date-time */
  createdAt?: string;
  /** @format date-time */
  updatedAt?: string;
}

export interface DiagramNodeDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  diagramId?: number | null;
  nodeType?: NodeType;
  text?: string | null;
  backgroundColor?: string | null;
  textColor?: string | null;
  /** @format int32 */
  variableId?: number | null;
  /** @format int32 */
  min1?: number | null;
  /** @format int32 */
  min2?: number | null;
  /** @format int32 */
  min3?: number | null;
  /** @format int32 */
  min4?: number | null;
  /** @format double */
  positionX?: number | null;
  /** @format double */
  positionY?: number | null;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
  createdAt?: string | null;
  updatedAt?: string | null;
  diagramNavigationType?: DiagramNavigationType;
  /** @format int32 */
  childDiagramId?: number | null;
  /** @format int32 */
  dashboardId?: number | null;
  isOn?: boolean | null;
  hasRange?: boolean | null;
  /** @format int32 */
  parentId?: number | null;
}

export interface EnviarAlertaRequest {
  mensaje?: string | null;
}

export interface ExecuteTasksInRangeRequestDto {
  taskIds?: number[] | null;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
  persistMetrics?: boolean;
}

export interface ExportTemplatePageDto {
  /** @format int32 */
  pageNumber?: number;
  name?: string | null;
  slots?: SlotDto[] | null;
}

export interface ForgotPasswordRequestDto {
  email?: string | null;
}

export interface GenericErrorDto {
  id?: ResponseCodes;
  location?: string | null;
  description?: string | null;
}

export interface IdentityRole {
  id?: string | null;
  name?: string | null;
  normalizedName?: string | null;
  concurrencyStamp?: string | null;
}

export interface Layout {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  x?: number | null;
  /** @format int32 */
  y?: number | null;
  /** @format int32 */
  i?: number | null;
  /** @format int32 */
  w?: number | null;
  /** @format int32 */
  h?: number | null;
  /** @format int32 */
  minW?: number | null;
  /** @format int32 */
  minH?: number | null;
  staticItem?: boolean | null;
  /** @format int32 */
  dashboardId?: number | null;
  dashboard?: Dashboard;
  chartQuery?: DashboardChartQuery;
}

export interface LayoutDto {
  /** @format int32 */
  id?: number;
  /** @format int32 */
  x?: number | null;
  /** @format int32 */
  y?: number | null;
  /** @format int32 */
  i?: number | null;
  /** @format int32 */
  w?: number | null;
  /** @format int32 */
  h?: number | null;
  /** @format int32 */
  minW?: number | null;
  /** @format int32 */
  minH?: number | null;
  staticItem?: boolean | null;
  /** @format int32 */
  dashboardId?: number;
}

export interface LoginRequestDto {
  email?: string | null;
  password?: string | null;
  twoFactorCode?: string | null;
  twoFactorRecoveryCode?: string | null;
}

export interface Metric {
  /** @format int32 */
  id?: number;
  /** @format double */
  valor?: number;
  /** @format date-time */
  timestamp?: string;
}

export interface Plant {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  plantName: string;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  /** @format int32 */
  clientId?: number;
  client?: Client;
  zones?: Zone[] | null;
  diagrams?: Diagram[] | null;
  dashboardGroup?: DashboardGroup[] | null;
  roles?: RolePermission[] | null;
}

export interface PlantDto {
  /** @format int32 */
  id?: number;
  plantName?: string | null;
  clientPhoneContact?: string | null;
  clientEmail?: string | null;
  /** @format int32 */
  clientId?: number;
  rolePermissions?: CreateEntityRolePermissionDto[] | null;
  permissionLevel?: PermissionLevel;
}

export interface ProblemDetails {
  type?: string | null;
  title?: string | null;
  /** @format int32 */
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
}

export interface RefreshTokenRequestDto {
  refreshToken?: string | null;
}

export interface ResetPasswordRequestDto {
  email?: string | null;
  token?: string | null;
  newPassword?: string | null;
}

export interface RoleDto {
  id?: string | null;
  name?: string | null;
}

export interface RolePermission {
  /** @format int32 */
  id?: number;
  roleId?: string | null;
  entityType?: EntityType;
  /** @format int32 */
  entityId?: number;
  permissionLevel?: PermissionLevel;
  role?: IdentityRole;
  entity?: any;
}

export interface RolePermissionDto {
  /** @format int32 */
  id?: number;
  roleId?: string | null;
  entityType?: EntityType;
  /** @format int32 */
  entityId?: number;
  permissionLevel?: PermissionLevel;
  entity?: any;
  role?: IdentityRole;
}

export interface SendMailRequestDto {
  email?: string | null;
  subject?: string | null;
  content?: string | null;
}

export interface SendTemplateExportRequestDto {
  /** @format int32 */
  exportTemplateId?: number;
  /** @format date-time */
  from?: string;
  /** @format date-time */
  to?: string;
  emails?: string[] | null;
  body?: string | null;
}

export interface SendTemplatedMailRequestDto {
  email?: string | null;
  subject?: string | null;
  /** @format int32 */
  templateType?: number;
  variables?: Record<string, string>;
}

export interface SingleValueChartStyle {
  /** @format int32 */
  fontSizeValue?: number;
  /** @format int32 */
  fontSizeLabel?: number;
  /** @format float */
  scaleX?: number;
  /** @format float */
  scaleY?: number;
  /** @format int32 */
  padding?: number;
}

export interface SingleValueChartStyleDto {
  /** @format int32 */
  fontSizeValue?: number;
  /** @format int32 */
  fontSizeLabel?: number;
  /** @format float */
  scaleX?: number;
  /** @format float */
  scaleY?: number;
  /** @format int32 */
  padding?: number;
}

export interface SlotDto {
  /** @format int32 */
  pageNumber?: number;
  cell?: string | null;
  /** @format int32 */
  variableId?: number;
  /** @format int32 */
  dataNumber?: number;
}

export interface StatisticsResponseDto {
  /** @format int32 */
  totalScadaVariables?: number;
  /** @format int32 */
  totalDashboards?: number;
  /** @format int32 */
  totalTasks?: number;
  /** @format int32 */
  totalUsers?: number;
}

export interface Table {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  tableName: string;
  tableType?: TableType;
  /** @format int32 */
  zoneId?: number;
  zone?: Zone;
  variables?: Variable[] | null;
}

export interface TableAdvanceDto {
  /** @format int32 */
  id?: number;
  tableType?: TableType;
  tableName?: string | null;
  /** @format int32 */
  zoneId?: number;
  monitorPath?: string | null;
  /** @format date-time */
  lastRead?: string | null;
}

export interface TableDto {
  /** @format int32 */
  id?: number;
  tableName?: string | null;
  tableType?: TableType;
  /** @format int32 */
  zoneId?: number;
}

export interface TestVariableTaskRequestDto {
  taskData?: CreateVariableTaskDto;
  /** @format date-time */
  startDate?: string | null;
  /** @format date-time */
  endDate?: string | null;
}

export interface UpdateBulkNodePositionRequest {
  /** @format int32 */
  id?: number;
  /** @format double */
  positionX?: number;
  /** @format double */
  positionY?: number;
  /** @format int32 */
  width?: number | null;
  /** @format int32 */
  height?: number | null;
}

export interface UpdateDataExportRequestDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  variables?: number[] | null;
  /** @format int32 */
  limit?: number;
  fromExpression?: string | null;
  toExpression?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  fileType?: ExportFileType;
  cronExpression?: string | null;
  timeZone?: string | null;
  emails?: string[] | null;
  userId?: string | null;
  /** @format int32 */
  exportTemplateId?: number | null;
}

export interface UpdateDataRangeRequestDto {
  /** @format date-time */
  rangeStartDate?: string | null;
  /** @format date-time */
  rangeEndDate?: string | null;
  shouldSendData?: boolean;
}

export interface UpdateDiagramRequestDto {
  name?: string | null;
  description?: string | null;
}

export interface UpdateExportTemplateRequest {
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  plantId?: number;
  /** @format int32 */
  templatePageNumber?: number;
  pages?: ExportTemplatePageDto[] | null;
  rowVersionBase64?: string | null;
}

export interface UpdateTemplateExportScheduleRequestDto {
  /** @format int32 */
  id?: number;
  name?: string | null;
  description?: string | null;
  /** @format int32 */
  exportTemplateId?: number;
  cronExpression?: string | null;
  timeZone?: string | null;
  fromExpression?: string | null;
  toExpression?: string | null;
  /** @format date-time */
  from?: string | null;
  /** @format date-time */
  to?: string | null;
  emails?: string[] | null;
  userId?: string | null;
}

export interface UpdateTicketStatusRequestDto {
  status: TicketStatus;
  /** @maxLength 1000 */
  resolutionNotes?: string | null;
  /** @maxLength 450 */
  assignedToUserId?: string | null;
}

export interface Variable {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  variableName: string;
  varType: VarType;
  description?: string | null;
  chartVariable?: ChartVariable[] | null;
  table?: Table;
  /** @format int32 */
  tableId?: number | null;
  operations?: VariableTaskVariable[] | null;
}

export interface VariableDto {
  /** @format int32 */
  id?: number;
  variableName?: string | null;
  varType?: VarType;
  description?: string | null;
  /** @format int32 */
  tableId?: number | null;
}

export interface VariableScadaDto {
  /** @format int32 */
  id?: number;
  variableName?: string | null;
  varType?: VarType;
  description?: string | null;
  scadaReferenceName?: string | null;
  /** @format int32 */
  tableId?: number | null;
}

export interface VariableTask {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  variableName: string;
  varType: VarType;
  description?: string | null;
  chartVariable?: ChartVariable[] | null;
  table?: Table;
  /** @format int32 */
  tableId?: number | null;
  operations?: VariableTaskVariable[] | null;
  calculationType: CalculationType;
  calculationFormula?: string | null;
  unitChange?: string | null;
  /** @format date-span */
  lookbackPeriod?: string | null;
  /** @maxLength 100 */
  cronExpression?: string | null;
  timeZone?: string | null;
  /** @format int32 */
  variableId?: number | null;
  variable?: Variable;
  /** @format int32 */
  zoneId?: number | null;
  zone?: Zone;
  formulaVariables?: VariableTaskVariable[] | null;
}

export interface VariableTaskDto {
  /** @format int32 */
  id?: number;
  variableName?: string | null;
  varType?: VarType;
  description?: string | null;
  calculationType?: CalculationType;
  calculationFormula?: string | null;
  unitChange?: string | null;
  /** @format date-span */
  lookbackPeriod?: string | null;
  cronExpression?: string | null;
  timeZone?: string | null;
  /** @format int32 */
  tableId?: number | null;
  /** @format int32 */
  zoneId?: number | null;
  /** @format int32 */
  variableId?: number | null;
  formulaVariables?: VariableTaskVariableDto[] | null;
}

export interface VariableTaskVariable {
  /** @format int32 */
  variableTaskId?: number;
  /** @format int32 */
  variableId?: number;
  /**
   * @minLength 1
   * @maxLength 200
   */
  referencia: string;
  variableTask?: VariableTask;
  variable?: Variable;
}

export interface VariableTaskVariableDto {
  /** @format int32 */
  variableTaskId?: number;
  /** @format int32 */
  variableId?: number;
  referencia?: string | null;
}

export interface Zone {
  /** @format int32 */
  id?: number;
  /** @minLength 1 */
  zoneName: string;
  /** @format int32 */
  plantId?: number;
  plant?: Plant;
  tables?: Table[] | null;
  tasks?: VariableTask[] | null;
  annotations?: Annotation[] | null;
}

export interface ZoneDto {
  /** @format int32 */
  id?: number;
  zoneName?: string | null;
  /** @format int32 */
  plantId?: number;
}
